
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

// Minimal initialization with better error handling
console.log('App initialization starting');

// Get root element for React mounting
const rootElement = document.getElementById("root");

// Pre-initialize emoji-mart to avoid loading issues after login
const preloadEmojiMart = async () => {
  try {
    // Preload emoji-mart dependencies
    console.log('Preloading emoji-mart dependencies');
    await Promise.all([
      import('@emoji-mart/data'),
      import('@emoji-mart/react')
    ]);
    console.log('Emoji-mart dependencies loaded successfully');
    return true;
  } catch (error) {
    console.warn('Failed to preload emoji-mart:', error);
    return false;
  }
};

// Pre-load DND to ensure it's ready before the app renders
const preloadDnd = async () => {
  try {
    await import('@hello-pangea/dnd');
    console.log('DnD library preloaded successfully');
    return true;
  } catch (error) {
    console.error('Failed to preload DnD library:', error);
    return false;
  }
};

// Clean any stale redux states that might be in session storage
try {
  // Clean up all potential redux state conflicts
  const staleKeys = [
    'redux-issues', 
    'emoji-mart-components', 
    'redux-persist',
    'react-dnd-state',
    'dnd-state'
  ];
  
  staleKeys.forEach(key => {
    if (sessionStorage.getItem(key)) {
      console.log(`Cleaning up stale state: ${key}`);
      sessionStorage.removeItem(key);
    }
    if (localStorage.getItem(key)) {
      console.log(`Cleaning up stale localStorage state: ${key}`);
      localStorage.removeItem(key);
    }
  });
  
  // Also clean any keys with 'redux' in the name
  Object.keys(sessionStorage).forEach(key => {
    if (key.includes('redux') || key.includes('dnd') || key.includes('react-beautiful')) {
      console.log(`Cleaning up detected stale state: ${key}`);
      sessionStorage.removeItem(key);
    }
  });
} catch (e) {
  console.warn('Session storage not available:', e);
}

if (rootElement) {
  // Pre-load dependencies before mounting the app
  Promise.all([
    preloadDnd(),
    preloadEmojiMart()
  ]).then(([dndLoaded, emojiMartLoaded]) => {
    try {
      const root = createRoot(rootElement);
      
      // Render the app with BrowserRouter
      root.render(
        <BrowserRouter>
          <App />
        </BrowserRouter>
      );
      
      console.log(`App mounted successfully. Dependencies loaded: DnD=${dndLoaded}, EmojiMart=${emojiMartLoaded}`);
    } catch (error) {
      console.error("Critical rendering error:", error);
      
      // Show user-friendly error on rendering failure
      rootElement.innerHTML = `
        <div style="padding: 20px; text-align: center; font-family: sans-serif;">
          <h2>Application Error</h2>
          <p>There was a problem loading the application.</p>
          <a href="/login" style="display: inline-block; background: #8E9196; color: white; border: none; padding: 8px 16px; border-radius: 4px; margin-top: 16px; text-decoration: none;">
            Go to Login
          </a>
        </div>
      `;
    }
  });
} else {
  console.error("Root element not found");
}
